<template>
  <div class="auth-menu pb-4 pt-7">
    <div v-if="loggedIn">
      <v-badge
        :content="totalItems"
        :value="!!totalItems"
        color="#5579C6"
        overlap
      >
        <v-btn
          icon
          :to="getPath(`/cart`)"
          class="auth-menu-cart"
          aria-label="Shopping cart"
        >
          <div>
            <v-img :src="require(`@/assets/icons/cart.webp`)" width="22" height="22"/>
          </div>
        </v-btn>
      </v-badge>
      <v-btn
        icon
        :to="getPath(`/my-tickets`)"
        aria-label="My tickets"
      >
        <div>
          <v-img :src="require(`@/assets/icons/my-ticket.webp`)" width="25" height="25"/>
        </div>
      </v-btn>
      <v-btn
        icon
        @click="$emit('openSidebarMenu')"
        aria-label="Open menu"
      >
        <v-icon
          color="#000000de"
          class="menu-icon"
        >
          {{ mdiMenu }}
        </v-icon>
      </v-btn>
    </div>
    <div v-else>
      <v-badge
        :content="totalItems"
        :value="!!totalItems"
        color="#5579C6"
        overlap
      >
        <v-btn
          icon
          :to="getPath(`/cart`)"
          class="auth-menu-cart"
          aria-label="Shopping cart"
        >
          <div>
            <v-img :src="require(`@/assets/icons/cart.webp`)" width="22" height="22"/>
          </div>
        </v-btn>
      </v-badge>
      <v-btn
        v-if="!isCulturePassEnable && !isGuestLogin"
        icon
        :to="getPath(`/auth`)"
        aria-label="Sign in"
      >
        <div>
          <v-img :src="require(`@/assets/icons/my-profile.webp`)" width="25" height="25"/>
        </div>
      </v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Options from 'vue-class-component'
import { mapGetters } from 'vuex'
import { mdiMenu } from '@mdi/js'
import { GetCaption } from '@/utils/util.language'
import { getPath } from '@/utils/general-utils'
import { AUTH_SIGN_OUT } from '@/store/types'

@Options({
  computed: {
    ...mapGetters([
      'getToken',
      'totalItems',
      'isCulturePassEnable',
      'isGuestLogin',
    ]),
  }
})
export default class AuthMenu extends Vue {
  mdiMenu = mdiMenu
  GetCaption = GetCaption
  getPath = getPath
  getToken!: string
  isGuestLogin!: boolean

  get loggedIn(): boolean {
    return !!this.getToken && !this.isGuestLogin
  }

  get isMyTickets(): boolean {
    const params = this.$route.path.split('/')
    return params.includes('my-tickets')
  }

  get isSignIn(): boolean {
    const params = this.$route.path.split('/')
    return params.includes('auth')
  }

  get isProfile(): boolean {
    const params = this.$route.path.split('/')
    return params.includes('profile')
  }

  async logout(): Promise<void> {
    this.$store.commit(AUTH_SIGN_OUT)
    await this.$store.dispatch('resetCheckoutCart')
    this.$router.push(getPath('/'))
    window.location.reload()
  }
}
</script>

<style lang="scss" scoped>
.auth-menu {
  display: flex;
  flex-direction: row;
}

.auth-menu-item {
  margin-top: 4px;
}

.auth-user {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.auth-user-greeting {
  font-size: 14px;
  color: var(--v-primary-base);
  margin-top: 14px;
}

.auth-menu__username {
  // margin-top: 8px;
  color: var(--v-body-text-base);
  padding: 0 20px 0 20px;
  text-align: center;
  margin: 5px 0 10px 0;
}

.theme--light.v-btn--active:hover::before, .theme--light.v-btn--active::before {
  opacity: 0 !important;
}

.menu-icon .v-icon__svg {
  height: 26px;
  width: 26px;
}
</style>

<style lang="scss">
.auth-menu-cart, a .v-btn--active .v-btn .v-btn--icon .v-btn--round .v-btn--router .theme--light .v-size--default {
  width: 30px !important;
  height: 30px !important;
}
</style>